import React, { useEffect, useState } from 'react'
import GenericDropdown from '../../generic/genericDropdown'
import CancelPaymentModal from './CancelPaymentModal'
import { useUcs } from '../../../helpers/contexts/UserCompanySettingsContext'

const PaymentRequestDropDown = ({ paymentRequest, updatePaymentRequests }) => {
  const [cancelModalVisible, setCancelModalVisible] = useState(false)
  const [showCancel, setShowCancel] = useState(false)
  const [dropdownItems, setDropdownItems] = useState([])
  const ucsContext = useUcs()

  useEffect(() => {
    if (!ucsContext.loaded) {
      return
    }
    if (ucsContext.userName() == paymentRequest.created_by || ucsContext.isAdmin()) {
      setShowCancel(true)
    }
  }, [ucsContext])

  useEffect(() => {
    if (!showCancel) {
      return
    }
    const cancelItem = dropdownItems.find((item) => item.id === 'cancel')
    if (cancelItem) {
      return
    }
    let newItems = [...dropdownItems]
    newItems.push(
      <a
        style={{
          color: 'red',
        }}
        onClick={() => {
          setCancelModalVisible(true)
        }}
      >
        Cancel
      </a>
    )
    setDropdownItems(newItems)
  }, [showCancel])

  return (
    <>
      <GenericDropdown dropdownItems={dropdownItems} />
      {cancelModalVisible && (
        <CancelPaymentModal
          visible={cancelModalVisible}
          handleCancelModal={() => setCancelModalVisible(false)}
          paymentRequest={paymentRequest}
          updatePaymentRequests={updatePaymentRequests}
        />
      )}
    </>
  )
}

export default PaymentRequestDropDown
